// Shared theme constants for the schema viewer

// Highlight colors for lineage visualization
export const HIGHLIGHT_COLORS = {
  selected: { bg: '#ede9fe', border: '#7c3aed' },
  predecessor: { bg: '#fef3c7', border: '#f59e0b' },
  successor: { bg: '#d1fae5', border: '#10b981' },
} as const;

export const EDGE_COLOR = '#6366f1';

// Node colors by TYPE — used when a node carries no database (e.g. the CR
// impact graph, where entities are methods/beans/procedures/applications).
// One color per type so "tables all one color, beans all one color".
export const TYPE_COLORS: Record<string, string> = {
  table: '#3b82f6',       // blue
  field: '#0ea5e9',       // sky
  procedure: '#f59e0b',   // amber
  method: '#10b981',      // emerald (beans/methods)
  bean: '#10b981',
  application: '#8b5cf6', // violet (apps / UI screens)
  ui: '#8b5cf6',
  module: '#8b5cf6',
  other: '#64748b',       // slate
  // Kinds added by Compass 2026-08-15 (thread change-graph #52)
  class: '#14b8a6',        // teal
  interface: '#06b6d4',    // cyan
  businessrule: '#f43f5e', // rose
  function: '#84cc16',     // lime
  carrier: '#a855f7',      // purple
};

export function getTypeColor(type: string): string {
  const key = (type || 'other').toLowerCase();
  if (TYPE_COLORS[key]) return TYPE_COLORS[key];
  // Stable fallback for unknown types
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  const palette = ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ef4444', '#0ea5e9', '#64748b'];
  return palette[h % palette.length];
}
export const BORDER_DEFAULT = '#e5e7eb';
export const BORDER_LIGHT = '#f3f4f6';
export const TEXT_SECONDARY = '#6b7280';

// Node/edge type discriminators
export const NODE_TYPE_DATABASE = 'database';
export const EDGE_TYPE_CONTAINS = 'contains';

// Highlight state type
export type HighlightState = 'selected' | 'predecessor' | 'successor' | null;
